import { TypedDocumentNode, gql } from '@apollo/client';
import { generatePath, useNavigate } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { FOOTBALL_PLAY_PRO_ONBOARDING_LEADERBOARD_FIRST_LINEUP } from '@sorare/core/src/constants/__generated__/routes';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { ChooseTeams } from 'components/onboarding/ChooseTeams';

import {
  ChooseTeamsQuery,
  ChooseTeamsQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const CHOOSE_TEAMS_QUERY = gql`
  query ChooseTeamsQuery($slug: String!) {
    so5 {
      so5Leaderboard(slug: $slug) {
        id
        slug
        ...ChooseTeams_so5Leaderboard
      }
    }
  }
  ${ChooseTeams.fragments.so5Leaderboard}
` as TypedDocumentNode<ChooseTeamsQuery, ChooseTeamsQueryVariables>;

const ChooseTeamsPage = () => {
  const { leaderboard } = useTypedParams<PageParams>();
  const navigate = useNavigate();
  const { data, loading } = useQuery(CHOOSE_TEAMS_QUERY, {
    variables: { slug: leaderboard },
  });
  const { so5Leaderboard } = data?.so5 || {};

  return (
    <ChooseTeams
      so5Leaderboard={so5Leaderboard}
      loading={loading}
      onSubmit={() =>
        navigate(
          generatePath(FOOTBALL_PLAY_PRO_ONBOARDING_LEADERBOARD_FIRST_LINEUP, {
            leaderboard,
          })
        )
      }
    />
  );
};
export default ChooseTeamsPage;
